<template>
  <div id="print">

    <div class="book m-auto">
      <div class="page">
        <div class="subpage">
          <div class="top-header">
            <div class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p class="max-line-3">{{ shopInfo.info.location.address }}</p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.pe') }}</h2>
              <p> {{ payment.pe_code }} </p>
            </div>
          </div>
          <div class="content">
            <div class="row mx-auto p-0 g-0 section-detail">
              <!-- LEFT -->
              <div class="col-6 p-0">
                <table class="table table-borderless border-0">
                  <colgroup>
                    <col width="60">
                    <col width="40%">
                  </colgroup>
                  <tr>
                    <td>{{ $t('message.typeofpaymententry') }}</td>
                    <td>
                      <div
                        v-if="payment.type == 'pay'"
                        class="">
                        {{ $t('message.checkboxexpense') }}
                      </div>
                      <div
                        v-else
                        class="">{{ $t('message.checkboxreceive') }} </div>
                    </td>
                  </tr>
                </table>

              </div>
              <!-- RIGHT -->
              <div class="col-6 p-0">
                <table class="table table-borderless border-0">
                  <colgroup>
                    <col width="60">
                    <col width="40%">
                  </colgroup>
                  <tr>
                    <td>{{ $t('message.reference') }}</td>
                    <td>
                      <div
                        v-if="data.po"
                        class="">{{ $t('documents.po') }}</div>
                      <div
                        v-if="data.in"
                        class="">{{ $t('documents.in') }} </div>
                      <div
                        v-if="data.prl"
                        class="">{{ $t('documents.prl') }} </div>
                      <div
                        v-if="data.ex"
                        class="">{{ $t('documents.ex') }} </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('message.series') }}</td>
                    <td>
                      <span v-if="data.in">{{ data.in.in_code }}</span>
                      <span v-if="data.prl">{{ data.prl.prlCode }}</span>
                      <span v-if="data.po">{{ data.po.po_code }}</span>
                      <span v-if="data.ex">{{ data.ex.ex_code }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- INFO -->
            <div class="row mx-auto p-0">
              <!-- Ref -->
              <div class="col-6 p-0">
                <table class="table table-borderless border-0">
                  <colgroup>
                    <col width="60">
                    <col width="40%">
                  </colgroup>
                  <tr v-if="payment.partner">
                    <td v-if="payment.partner.vendor">{{ $t('message.vendor') }}</td>
                    <td v-if="payment.partner.vendor">{{ payment.partner.vendor.vendor_name }}</td>
                    <td v-if="payment.partner.customer">{{ $t('message.customer') }}</td>
                    <td v-if="payment.partner.customer">{{ payment.partner.customer.customer_name }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('message.debttotal') }}
                    </td>
                    <td>
                      <div
                        v-if="data.po"
                        class="">{{ getNumber(getDebtPurchaseAmount(data.po)) }} </div>
                      <div
                        v-if="data.in"
                        class="">{{ getNumber(getDebtInvoiceAmount(data.in)) }} </div>
                      <div
                        v-if="data.prl"
                        class="">{{ getNumber(getDebtPayslipAmount(data.prl)) }} </div>
                      <div
                        v-if="data.ex"
                        class="">{{ getNumber(getDebtExpenseAmount(data.ex)) }} </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('message.paidtotal') }}
                    </td>
                    <td>
                      <div
                        v-if="data.po"
                        class="">{{ getNumber(getPaidAmount(data.po.reference.payments)) }} </div>
                      <div
                        v-if="data.in"
                        class="">{{ getNumber(getPaidAmount(data.in.reference.payments)) }} </div>
                      <div
                        v-if="data.prl"
                        class="">{{ getNumber(data.prl.net - data.prl.process.debit) }} </div>
                      <div
                        v-if="data.ex"
                        class="">{{ getNumber(getPaidAmount(data.ex.reference.payments)) }} </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('message.grandtotal') }}
                    </td>
                    <td>
                      <div
                        v-if="data.po"
                        class="">{{ getNumber(getTotal(data.po.orders).payment) }} </div>
                      <div
                        v-if="data.in"
                        class="">{{ getNumber(getTotal(data.in.orders).payment) }} </div>
                      <div
                        v-if="data.prl"
                        class="">{{ getNumber(data.prl.net) }} </div>
                      <div
                        v-if="data.ex"
                        class="">{{ getNumber(data.ex.payment.amount) }} </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- Detail -->
              <div class="col-6 p-0">
                <table class="table table-borderless border-0">
                  <colgroup>
                    <col width="60">
                    <col width="40%">
                  </colgroup>
                  <tr>
                    <td>
                      <div class="">{{ $t('message.type') }}</div>
                    </td>
                    <td>
                      <div v-if="form.payment_type=='cash'">{{ $t('message.cash') }}</div>
                      <div v-if="form.payment_type=='card'">{{ $t('message.creditcard') }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('message.postingpaiddate') }}</td>
                    <td>{{ getDate(form.payment_date) }}</td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('message.paidamount', {string:currency}) }}
                    </td>
                    <td>
                      {{ getNumber(form.payment_amount) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div
              v-if="form.note"
              class="row mx-auto mt-4">
              <div class="col-12">
                {{ $t('message.note') }}
              </div>
              <div class="col-12 mt-3">
                {{ form.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  name: 'Printpe',
  props: {
    data: {
      type: Object,
    },
    payment: {
      type: Object,
    },
    form: {
      type: Object,
    },
  },
  data () {
    return {
      maxOrderLists: 15,

    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      currency: 'getCurrency',

    }),
  },
}

</script>

<style scoped>
@page {
    size: A4;
    margin: 0;
}

@media print {
    #print .page {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
    }
}

.section-detail {
  border-bottom: solid 1px #D1D8DD;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/invoice/include/PrintPE.vue